import { omitBy } from 'lodash';
import { objectToQueryString } from 'site-modules/shared/utils/string';

export const getMultiOfferResultsLink = ({ modsId, isAbsolute = false, isAppExtensionPage, queryParams = {} }) => {
  const queryString = decodeURIComponent(objectToQueryString(omitBy(queryParams, param => !param)));
  let path = `/sell-car/offers/${modsId}/`;

  // Check if SSR to avoid accessing the window.location
  if (typeof window !== 'undefined' && isAbsolute) {
    return `${location.origin}${path}`;
  }

  if (isAppExtensionPage) path += 'index.app';

  return `${path}${queryString.length ? '?' : ''}${queryString}`;
};

export const getOfferDetailsPageLink = ({ modsId, isAbsolute = false, isAppExtensionPage, queryParams = {} }) => {
  const queryString = decodeURIComponent(objectToQueryString(omitBy(queryParams, param => !param)));

  if (!modsId) {
    return undefined;
  }

  let path = `/sell-car/offer/carmax/${modsId}/`;

  // Check if SSR to avoid accessing the window.location
  if (typeof window !== 'undefined' && isAbsolute) {
    return `${location.origin}${path}`;
  }

  if (isAppExtensionPage) path += 'index.app';

  return `${path}${queryString.length ? '?' : ''}${queryString}`;
};
